/* eslint-disable react/prop-types */
import {
  Form,
  Modal,
  Row,
  Spin,
} from 'antd';
import getHistoricosModificacionJornadasOptimized from 'api/nominas/historicoModificacionJornadas';
import { checkToken } from 'api/utils';
import Dragger from 'components/Dragger';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import HTTP, { baseURL } from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { getModelPermission } from 'utils/permission';

export const HistoricoMovimientoEmpleadoPermission = {
  permissionModel: 'historicomovimientoempleado',
  catalogsModels: [],
  tabsModels: [],
};

const baseURI = 'nominas/movimientos-empleados-importar-excel';

const ExpedienteJornadas = ({
  currentEmpleado,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [formCarga] = Form.useForm();
  const [pageActual, setPageActual] = useState(1);

  const getPermission = getModelPermission(
    HistoricoMovimientoEmpleadoPermission.permissionModel,
    HistoricoMovimientoEmpleadoPermission.catalogsModels,
    HistoricoMovimientoEmpleadoPermission.tabsModels,
    false,
  );

  const fetchData = async () => {
    if (!currentEmpleado) return;
    setLoading(true);
    const _data = await getHistoricosModificacionJornadasOptimized(
      { empleado: currentEmpleado },
    );
    setData(formatReceived(_data));
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
      ] = await Promise.all([
        getHistoricosModificacionJornadasOptimized({ empleado: currentEmpleado }),
      ]);
      if (mounted) {
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const onCancel = () => {
    setVisibleModal(false);
    formCarga.resetFields();
  };

  // const onClickObtenerPlantilla = async () => {
  //   try {
  //     setLoading(true);
  //     const excel = await getHistoricoMovimientosEmpleadosPlantilla();
  //     if (excel) {
  //       const blob = new Blob([excel], {
  //         type: 'application/ms-excel',
  //       });
  //       const url = URL.createObjectURL(blob);
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.download = 'HistoricoMovimientoEmpleado_Plantilla.xlsx';
  //       link.click();
  //     }
  //     setLoading(false);
  //   } catch (err) {
  //     onError(err);
  //   }
  // };

  // const onClickCargar = () => {
  //   setVisibleModal(true);
  // };

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
        const response = await HTTP.post(`${baseURL}${uri}`, formData, {
          headers: {
            'Content-Type': 'application/ms-excel',
          },
          responseType: 'arraybuffer',
        });
        if (response?.data) {
          const blob = new Blob([response?.data], {
            type: 'application/ms-excel',
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'HistoricoMovimientoEmpleado_Respuesta.xlsx';
          link.click();
        }
        if (response?.status === 200) {
          onSuccess(response, 'Operación realizada correctamente', 5);
          await fetchData();
          onCancel();
        }
      }
      setLoading(false);
      setVisibleModal(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // const menuImport = (
  //   <Menu
  //     items={[
  //       {
  //         key: 1,
  //         label: 'Obtener Plantilla',
  //         text: 'Obtener Plantilla',
  //         icon: <FileExcelOutlined />,
  //         onClick: () => onClickObtenerPlantilla(),
  //       },
  //       {
  //         key: 2,
  //         label: 'Cargar',
  //         text: 'Cargar',
  //         icon: <DownloadOutlined />,
  //         onClick: () => onClickCargar(),
  //       },
  //     ]}
  //   />
  // );

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  const columns = [
    {
      titleText: 'Jornada',
      dataIndex: 'jornada',
      key: 'jornada',
      width: 200,
    },
    {
      titleText: 'Horario',
      dataIndex: 'horario',
      key: 'horario',
      width: 200,
    },
    {
      titleText: 'No. de Oficio',
      dataIndex: 'numero_de_oficio',
      key: 'numero_de_oficio',
      width: 200,
    },
    {
      titleText: 'Fecha del Oficio',
      dataIndex: 'fecha_del_oficio',
      key: 'fecha_del_oficio',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 300,
      render: (val) => (moment.isMoment(val)
        ? val.format('YYYY-MM-DD') : moment(val).format('YYYY-MM-DD'))
      ,
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          permission={getPermission}
          // allowCustomImport
          // customImportMenu={menuImport}
          // customImportText="Importar Movimientos Empleados"
          // allowExportPDF={false}
          loading={loading}
        />
        <Modal
          open={visibleModal}
          title={(
            <FormSubmitControls
              label="Carga Masiva"
              onFinish={onUpload}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name="carga"
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={rules.required}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>
      </Spin>
    </Row>
  );
};

export default ExpedienteJornadas;
